<div class="row">
    <div class="col-12">
        <h4 class="fw-bold">
            {{ "metrics.title" | translate }}
            <span class="fw-light mx-1">
                @if (displayLabel) {
                    - {{ displayLabel }}
                }
            </span>

            @if (relatedKpis() && relatedKpis().length) {
                <i class="fa fa-warning text-warning pointer" (click)="unlinkModal().open()"></i>
            }
        </h4>
    </div>
</div>

<form [formGroup]="metricsForm">
    <div class="bg-card shadow-md rounded p-2 mb-3">
        <div class="row">
            <div
                [class.col-md-6]="isDimensionMetric && AdaaHelper.isPMOEntity()"
                [class.col-md-12]="!isDimensionMetric || !AdaaHelper.isPMOEntity()"
                class="col-sm-12"
            >
                <adaa-form-dropdown
                    controlName="type"
                    formControlName="type"
                    [label]="'metrics.label_type' | translate"
                    [setValidator]="formValidation()!"
                    [clearable]="true"
                    [options]="mainTypes()"
                    [invalid]="submitted && metricsForm.get('type')?.invalid!"
                    (inputChanges)="metricTypeChange($event)"
                />
            </div>
            @if (isDimensionMetric && AdaaHelper.isPMOEntity()) {
                <div class="col-md-6 col-sm-12">
                    <adaa-form-dropdown
                        controlName="dashboardType"
                        formControlName="dashboardType"
                        [label]="'metrics.dashboard_type' | translate"
                        [setValidator]="formValidation()!"
                        [clearable]="true"
                        [options]="dashboardTypes()"
                        [invalid]="submitted && metricsForm.get('dashboardType')?.invalid!"
                    />
                </div>
            }
        </div>

        @if (isDimensionMetric) {
            <adaa-metrics-dimensions-editor
                [pageMode]="pageMode()"
                [submitted]="submitted"
                [formValidation]="formValidation()"
                [metric]="metric()"
                (formChanged)="metricsForm.patchValue($event)"
                (parentMetricChanged)="parentMetricChanged($event)"
            />
        } @else {
            <div class="row">
                <div class="col-12">
                    <adaa-form-dropdown-multi
                        controlName="entityIds"
                        formControlName="entityIds"
                        [clearable]="true"
                        [label]="'common.form.label.entities' | translate"
                        [setValidator]="formValidation()!"
                        [options]="entities()"
                        [invalid]="submitted && metricsForm.get('entityIds')?.invalid!"
                    />
                </div>
            </div>
        }
    </div>

    <div class="bg-card shadow-md rounded p-2 mb-3">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <adaa-form-input
                    controlName="nameAE"
                    formControlName="nameAE"
                    [label]="'common.form.label.nameAE' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && metricsForm.get('nameAE')?.invalid!"
                />
            </div>
            <div class="col-md-6 col-sm-12">
                <adaa-form-input
                    controlName="nameEN"
                    formControlName="nameEN"
                    [label]="'common.form.label.nameEN' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && metricsForm.get('nameEN')?.invalid!"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <adaa-form-input
                    controlName="dscAE"
                    formControlName="dscAE"
                    [isTextArea]="true"
                    [label]="'common.form.label.descriptionAE' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && metricsForm.get('dscAE')?.invalid!"
                />
            </div>
            <div class="col-md-6 col-sm-12">
                <adaa-form-input
                    controlName="dscEN"
                    formControlName="dscEN"
                    [label]="'common.form.label.descriptionEN' | translate"
                    [isTextArea]="true"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && metricsForm.get('dscEN')?.invalid!"
                />
            </div>
        </div>
        <div class="row">
            <div [class.col-md-6]="isDimensionMetric" [class.col-md-12]="!isDimensionMetric" class="col-sm-12">
                <adaa-form-dropdown
                    controlName="dataType"
                    formControlName="dataType"
                    [label]="'metrics.label_data_type' | translate"
                    [setValidator]="formValidation()!"
                    [clearable]="true"
                    [options]="dataTypes()"
                    [invalid]="submitted && metricsForm.get('dataType')?.invalid!"
                />
            </div>
            @if (isDimensionMetric) {
                <div class="col-md-6 col-sm-12">
                    <adaa-form-dropdown
                        controlName="monthDifference"
                        formControlName="monthDifference"
                        [label]="'metrics.month_difference' | translate"
                        [setValidator]="formValidation()!"
                        [options]="monthDifferenceOptions()"
                        [invalid]="submitted && metricsForm.get('monthDifference')?.invalid!"
                    />
                </div>
            }
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <adaa-form-input
                    controlName="dataSourceAE"
                    formControlName="dataSourceAE"
                    [label]="'metrics.data_source_ae' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && metricsForm.get('dataSourceAE')?.invalid!"
                />
            </div>
            <div class="col-md-6 col-sm-12">
                <adaa-form-input
                    controlName="dataSourceEN"
                    formControlName="dataSourceEN"
                    [label]="'metrics.data_source_en' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && metricsForm.get('dataSourceEN')?.invalid!"
                />
            </div>
        </div>
        <div class="row my-3">
            <div class="col-sm-12 d-flex justify-content-center" [class.col-md-6]="!isGlobalMetric" [class.col-md-4]="isGlobalMetric">
                <adaa-form-checkbox
                    controlName="available"
                    formControlName="available"
                    [label]="'metrics.available' | translate"
                    checkboxMode="yesNo"
                    [boldLabel]="true"
                />
            </div>
            <div class="col-sm-12 d-flex justify-content-center" [class.col-md-6]="!isGlobalMetric" [class.col-md-4]="isGlobalMetric">
                <adaa-form-checkbox
                    controlName="validForFuture"
                    formControlName="validForFuture"
                    [label]="'metrics.valid_for_future' | translate"
                    checkboxMode="yesNo"
                    [boldLabel]="true"
                />
            </div>
            @if (isGlobalMetric) {
                <div class="col-md-4 col-sm-12 d-flex justify-content-center">
                    <adaa-form-checkbox controlName="aiUsage" formControlName="aiUsage" [label]="'metrics.ai_usage' | translate" [boldLabel]="true" />
                </div>
            }
        </div>
    </div>
</form>

@if (isViewMode()) {
    <div class="py-2">
        <adaa-metrics-reading-details [metricId]="+id()" [metricType]="metric()?.type" [enableActionCell]="true" [isMetricPage]="true" />
    </div>
}

<div class="my-2">
    <adaa-form-action-buttons
        saveButtonTitle="common.form.button.submit"
        [cancelButtonTitle]="isViewMode() ? 'common.form.button.close' : 'common.form.button.cancel'"
        [showSaveButton]="!isViewMode()"
        (saveClicked)="submit()"
        (cancelClicked)="goBack()"
    />
</div>

<adaa-metric-unlink-information #unlink title="metrics.metrics_used_kpi" [showMessage]="false" [data]="relatedKpis()" />
